// Search results controller (no Alpine): collection-style AJAX filtering + swatches +
// price slider + seamless infinite scroll (prefetch buffer). Emits/consumes the same
// markup contract as the collection page:
//   [data-search-root]              → bootstrap gate (holds data-search-url / data-search-q)
//   [data-product-grid] .grid       → live grid
//   [data-product-card] [data-product-id] → cards (dedupe key)
//   [data-pagination] [data-next-url] → next page url
//   [data-infinite-sentinel]        → observer target
//   [data-search-filters]           → sidebar body (swapped on filter apply)
//   [data-filter-toggle="param=val"] → list checkbox / colour swatch
//   [data-price-slider]             → dual-range price
//   [data-search-sort]              → sort <select>
(function () {
  var root = document.querySelector('[data-search-root]');
  if (!root) return;

  var SEARCH_URL = root.getAttribute('data-search-url') || '/search';
  var SEARCH_Q = root.getAttribute('data-search-q') || '';

  var state = {
    observer: null,
    fetchedUrls: new Set(),
    chunks: [],
    fetching: false,
    bufferNextUrl: null,
    isLoading: false
  };

  function origin() { return window.location.origin; }
  function fetchDoc(url) {
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); });
  }
  function extractNextUrl(doc) {
    var el = doc.querySelector('[data-pagination] [data-next-url]');
    if (el && el.getAttribute('data-next-url')) return el.getAttribute('data-next-url');
    var a = doc.querySelector('[data-pagination] a[rel="next"]') ||
            doc.querySelector('[data-pagination] a[aria-label*="Next" i]') ||
            doc.querySelector('[data-pagination] a[href*="page="]');
    return a ? a.getAttribute('href') : null;
  }

  // ---------- infinite scroll (prefetch buffer) ----------
  function currentGrid() { return document.querySelector('[data-product-grid] .grid'); }
  function appendCards(cards) {
    var grid = currentGrid();
    if (!grid || !cards || !cards.length) return;
    var seen = new Set();
    grid.querySelectorAll('[data-product-card] [data-product-id]').forEach(function (el) {
      var id = el.getAttribute('data-product-id'); if (id) seen.add(id);
    });
    var frag = document.createDocumentFragment();
    cards.forEach(function (card) {
      var idEl = card.querySelector('[data-product-id]');
      var id = idEl ? idEl.getAttribute('data-product-id') : null;
      if (!id || !seen.has(id)) { frag.appendChild(card.cloneNode(true)); if (id) seen.add(id); }
    });
    grid.appendChild(frag);
  }
  var LOOKAHEAD = 1, NEAR = 1400;
  function sentinelNear() {
    var sn = document.querySelector('[data-infinite-sentinel]');
    if (!sn) return false;
    return sn.getBoundingClientRect().top < window.innerHeight + NEAR;
  }
  function fillBuffer() {
    if (state.fetching || !state.bufferNextUrl || state.chunks.length >= LOOKAHEAD) return;
    var url = state.bufferNextUrl;
    if (state.fetchedUrls.has(url)) return;
    state.fetchedUrls.add(url);
    state.fetching = true;
    fetchDoc(url).then(function (doc) {
      state.chunks.push(Array.prototype.slice.call(doc.querySelectorAll('[data-product-grid] [data-product-card]')));
      state.bufferNextUrl = extractNextUrl(doc);
      state.fetching = false;
      fillBuffer();
      tick();
    }).catch(function () { state.fetchedUrls.delete(url); state.fetching = false; });
  }
  function tick() {
    if (state.isLoading) return;
    while (state.chunks.length && sentinelNear()) appendCards(state.chunks.shift());
    if (state.bufferNextUrl) fillBuffer();
    else if (!state.chunks.length) disconnectSentinel();
  }
  function setupSentinel() {
    disconnectSentinel();
    var sentinel = document.querySelector('[data-infinite-sentinel]');
    if (!sentinel) return;
    state.observer = new IntersectionObserver(function (entries) {
      if (entries[0] && entries[0].isIntersecting) tick();
    }, { rootMargin: NEAR + 'px 0px', threshold: 0 });
    state.observer.observe(sentinel);
  }
  function disconnectSentinel() { if (state.observer) { state.observer.disconnect(); state.observer = null; } }
  function resetInfinite() { disconnectSentinel(); state.fetchedUrls.clear(); state.chunks = []; state.fetching = false; state.bufferNextUrl = null; }

  // ---------- AJAX apply (no full-page reload, no loading UI) ----------
  function fetchSearch(url, updateHistory) {
    if (state.isLoading) return;
    state.isLoading = true;
    resetInfinite();
    fetchDoc(url).then(function (doc) {
      if (updateHistory !== false) window.history.pushState({}, '', url);
      swapInner('[data-product-grid]', doc);
      swapInner('[data-search-filters]', doc);
      var nc = doc.querySelector('[data-search-count]');
      var cc = document.querySelector('[data-search-count]');
      if (nc && cc) cc.textContent = nc.textContent;
      var total = (nc ? nc.textContent : '').replace(/[^0-9]/g, '');
      if (total) document.querySelectorAll('[data-result-total]').forEach(function (el) { el.textContent = total; });
      state.bufferNextUrl = extractNextUrl(doc);
      initPriceSliders();
      var top = document.querySelector('[data-search-top]');
      if (top) top.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }).catch(function () { /* noop */ }).then(function () {
      state.isLoading = false;
      setupSentinel();
      fillBuffer();
      tick();
    });
  }
  function swapInner(sel, doc) {
    var nu = doc.querySelector(sel), cur = document.querySelector(sel);
    if (nu && cur) cur.innerHTML = nu.innerHTML;
  }

  // Build a URL off the current location, mutating its query params.
  function buildUrl(mutate) {
    var u = new URL(window.location.href, origin());
    if (!u.searchParams.get('q') && SEARCH_Q) u.searchParams.set('q', SEARCH_Q);
    mutate(u.searchParams);
    u.searchParams.delete('page');
    return u.pathname + '?' + u.searchParams.toString();
  }
  // Toggle one "name=value" pair, honouring multi-valued params (e.g. product_type).
  function toggleFilter(pair) {
    var i = pair.indexOf('=');
    if (i < 0) return;
    var name = pair.slice(0, i), val = pair.slice(i + 1);
    return buildUrl(function (p) {
      var vals = p.getAll(name);
      var idx = vals.indexOf(val);
      p.delete(name);
      if (idx > -1) vals.splice(idx, 1); else vals.push(val);
      vals.forEach(function (v) { p.append(name, v); });
    });
  }

  // ---------- price range slider (ported from collection.js) ----------
  function psBounds(s) {
    var lo = +s.querySelector('[data-ps-min]').value;
    var hi = +s.querySelector('[data-ps-max]').value;
    return lo <= hi ? [lo, hi] : [hi, lo];
  }
  function syncPriceSlider(s, moved) {
    var floor = +s.getAttribute('data-min');
    var ceil = +s.getAttribute('data-max') || 1;
    var minEl = s.querySelector('[data-ps-min]');
    var maxEl = s.querySelector('[data-ps-max]');
    if (!minEl || !maxEl) return;
    if (moved === minEl && +minEl.value > +maxEl.value) minEl.value = maxEl.value;
    if (moved === maxEl && +maxEl.value < +minEl.value) maxEl.value = minEl.value;
    var b = psBounds(s), lo = b[0], hi = b[1];
    var span = (ceil - floor) || 1;
    var range = s.querySelector('[data-ps-range]');
    if (range) {
      range.style.left = ((lo - floor) / span * 100) + '%';
      range.style.width = ((hi - lo) / span * 100) + '%';
    }
    var ll = s.querySelector('[data-ps-min-label]'), hl = s.querySelector('[data-ps-max-label]');
    if (ll) ll.textContent = '$' + lo;
    if (hl) hl.textContent = '$' + hi + (hi >= ceil ? '+' : '');
  }
  function applyPriceSlider(s) {
    var floor = +s.getAttribute('data-min'), ceil = +s.getAttribute('data-max');
    var b = psBounds(s), lo = b[0], hi = b[1];
    var gte = s.getAttribute('data-param-gte'), lte = s.getAttribute('data-param-lte');
    var url = buildUrl(function (p) {
      p.delete(gte); p.delete(lte);
      if (lo > floor) p.set(gte, lo);
      if (hi < ceil) p.set(lte, hi);
    });
    fetchSearch(url);
  }
  function initPriceSliders() {
    document.querySelectorAll('[data-price-slider]').forEach(function (s) { syncPriceSlider(s); });
  }

  // ---------- mobile filter drawer ----------
  function openDrawer() {
    var p = document.querySelector('[data-search-sidebar]');
    var b = document.querySelector('[data-search-backdrop]');
    if (p) p.classList.add('is-open');
    if (b) b.classList.add('is-open');
    document.body.classList.add('overflow-hidden');
  }
  function closeDrawer() {
    var p = document.querySelector('[data-search-sidebar]');
    var b = document.querySelector('[data-search-backdrop]');
    if (p) p.classList.remove('is-open');
    if (b) b.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
  }

  // ---------- event wiring ----------
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  document.addEventListener('click', function (e) {
    var el;
    if ((el = e.target.closest('[data-accordion-toggle]'))) {
      var acc = el.closest('[data-accordion]');
      if (acc) acc.classList.toggle('is-open');
      return;
    }
    if ((el = e.target.closest('[data-filter-toggle]'))) {
      e.preventDefault();
      el.classList.toggle('is-checked');
      var url = toggleFilter(el.getAttribute('data-filter-toggle'));
      if (url) fetchSearch(url);
      return;
    }
    if ((el = e.target.closest('[data-search-clear]'))) {
      e.preventDefault();
      fetchSearch(SEARCH_URL + '?q=' + encodeURIComponent(SEARCH_Q) + '&options[prefix]=last');
      return;
    }
    if ((el = e.target.closest('[data-cols-desktop-set]'))) {
      var nd = +el.getAttribute('data-cols-desktop-set');
      try { localStorage.setItem('tc_collection_desktop_cols', nd); } catch (er) {}
      document.documentElement.classList.toggle('tc-dcols-4', nd === 4);
      document.querySelectorAll('[data-cols-desktop-set]').forEach(function (b) {
        b.classList.toggle('is-active', +b.getAttribute('data-cols-desktop-set') === nd);
      });
      return;
    }
    if ((el = e.target.closest('[data-search-filter-toggle]'))) { openDrawer(); return; }
    if ((el = e.target.closest('[data-search-close]'))) { closeDrawer(); return; }
    if ((el = e.target.closest('[data-search-backdrop]'))) { closeDrawer(); return; }
    if ((el = e.target.closest('[data-sort-toggle]'))) {
      var menu = document.querySelector('[data-sort-menu]');
      if (menu) menu.hidden = !menu.hidden;
      e.stopPropagation();
      return;
    }
    if ((el = e.target.closest('[data-sort-option]'))) {
      var val = el.getAttribute('data-sort-option');
      var label = document.querySelector('[data-sort-label]');
      if (label) label.textContent = el.getAttribute('data-sort-text') || label.textContent;
      document.querySelectorAll('[data-sort-option]').forEach(function (o) { o.classList.toggle('is-active', o === el); });
      var m = document.querySelector('[data-sort-menu]'); if (m) m.hidden = true;
      fetchSearch(buildUrl(function (p) { p.set('sort_by', val); }));
      return;
    }
    // click-away closes the sort menu
    if (!e.target.closest('[data-search-sort]')) {
      var openMenu = document.querySelector('[data-sort-menu]');
      if (openMenu && !openMenu.hidden) openMenu.hidden = true;
    }
  });

  document.addEventListener('input', function (e) {
    var s = e.target.closest && e.target.closest('[data-price-slider]');
    if (s) syncPriceSlider(s, e.target);
  });
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || !el.closest) return;
    var s = el.closest('[data-price-slider]');
    if (s && (el.hasAttribute('data-ps-min') || el.hasAttribute('data-ps-max'))) { applyPriceSlider(s); return; }
  });

  window.addEventListener('popstate', function () { fetchSearch(window.location.href, false); });
  window.addEventListener('scroll', function () { if (sentinelNear()) tick(); }, { passive: true });

  // ---------- boot ----------
  initPriceSliders();
  try {
    var dcols = localStorage.getItem('tc_collection_desktop_cols') === '3' ? 3 : 4;
    document.querySelectorAll('[data-cols-desktop-set]').forEach(function (b) {
      b.classList.toggle('is-active', +b.getAttribute('data-cols-desktop-set') === dcols);
    });
  } catch (e) {}
  state.bufferNextUrl = extractNextUrl(document);
  setupSentinel();
  fillBuffer();
  tick();
})();
